var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataAnalytic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#65D3E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#FAFAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2400_3249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7305 49.2656H28.1406C27.7227 49.2656 27.3828 49.6055 27.3828 50.0234C27.3828 50.4414 27.7227 50.7812 28.1406 50.7812H40.7305C41.1484 50.7812 41.4883 50.4414 41.4883 50.0234C41.4883 49.6016 41.1484 49.2656 40.7305 49.2656Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2031 31.1094H27.8242C25.1758 31.1094 23.0195 33.2656 23.0195 35.9141C23.0195 38.5625 25.1758 40.7187 27.8242 40.7187C30.4727 40.7187 32.6289 38.5625 32.6289 35.9141V35.5352H28.2031V31.1094ZM31.8516 36.2969C31.6602 38.3516 29.9258 39.9648 27.8242 39.9648C25.5937 39.9648 23.7773 38.1484 23.7773 35.918C23.7773 33.8164 25.3906 32.082 27.4453 31.8906V36.2969H31.8516Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1094 30.7031V34.4023H32.8086C32.8086 32.3594 31.1523 30.7031 29.1094 30.7031Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1602 46.6133C51.3242 46.6133 49.7891 47.9219 49.4375 49.6523H44.918C44.4609 49.6523 44.1289 49.5625 44.0117 49.4062C43.9336 49.3008 43.9336 49.1328 43.9336 49.0547V47.0586H48.2266C49.6914 47.0586 50.8789 45.8672 50.8789 44.4062V27.1875C50.8789 25.7227 49.6875 24.5352 48.2266 24.5352H20.6484C19.1836 24.5352 17.9961 25.7266 17.9961 27.1875V44.4023C17.9961 45.8672 19.1875 47.0547 20.6484 47.0547H42.4141V49.0547C42.4141 49.2422 42.4141 49.8086 42.8008 50.3203C43.2266 50.8828 43.9375 51.168 44.918 51.168H56.957V50.4102C56.957 48.3164 55.2539 46.6133 53.1602 46.6133ZM20.6484 45.543C20.0195 45.543 19.5117 45.0312 19.5117 44.4062V27.1875C19.5117 26.5586 20.0234 26.0508 20.6484 26.0508H48.2227C48.8516 26.0508 49.3594 26.5625 49.3594 27.1875V44.4023C49.3594 45.0312 48.8477 45.5391 48.2227 45.5391H20.6484V45.543ZM53.1602 49.6523H51.0078C51.3203 48.7656 52.168 48.1289 53.1602 48.1289C54.1523 48.1289 55 48.7656 55.3125 49.6523H53.1602Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7031 30.8672H35.5156C35.3047 30.8672 35.1367 31.0352 35.1367 31.2461C35.1367 31.457 35.3047 31.625 35.5156 31.625H43.707C43.918 31.625 44.0859 31.457 44.0859 31.2461C44.0859 31.0352 43.9141 30.8672 43.7031 30.8672Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7031 33.7305H35.5156C35.3047 33.7305 35.1367 33.8984 35.1367 34.1094C35.1367 34.3203 35.3047 34.4883 35.5156 34.4883H43.707C43.918 34.4883 44.0859 34.3203 44.0859 34.1094C44.0859 33.8984 43.9141 33.7305 43.7031 33.7305ZM43.7031 36.5977H38.0156C37.8047 36.5977 37.6367 36.7656 37.6367 36.9766C37.6367 37.1875 37.8047 37.3555 38.0156 37.3555H43.7031C43.9141 37.3555 44.082 37.1875 44.082 36.9766C44.082 36.7656 43.9141 36.5977 43.7031 36.5977Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7031 39.4609H38.207C37.9961 39.4609 37.8281 39.6289 37.8281 39.8398C37.8281 40.0508 37.9961 40.2187 38.207 40.2187H43.7031C43.9141 40.2187 44.082 40.0508 44.082 39.8398C44.082 39.6289 43.9141 39.4609 43.7031 39.4609Z",
    fill: "#0B4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_3249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(17.5 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalytic);
export default __webpack_public_path__ + "static/media/data-analytic.8d1852620905a1691ea26a09a04e55c6.svg";
export { ForwardRef as ReactComponent };